module.exports = __webpack_public_path__ + "static/profile-pic-7fc88750bde9a9a7561d84e85802d892.jpg";